<template>
  <div class="w-100">
    <h1 class="font-md bold-medium ion-padding-bottom">
      {{ t('property.availableAccommodations') }}
    </h1>
    <ion-row>
      <ion-col size="4" v-for="(rentalUnit, index) in displayedRentalUnits" :key="index">
        <RentalUnitShow :hide-price="hidePrice" :rental-unit="rentalUnit" :language="language" />
      </ion-col>
    </ion-row>
    <ion-row v-if="rentalUnits && rentalUnits?.length > 3">
      <ion-col size="12">
        <ion-button expand="block" fill="outline" @click="showAll = !showAll"
          >{{ !showAll ? t('actions.showAll') : t('actions.hideAll') }} ({{ rentalUnits?.length }})
        </ion-button>
      </ion-col>
    </ion-row>
  </div>
</template>
<script setup lang="ts">
  import { IonRow, IonCol, IonButton } from '@ionic/vue';
  import { RentalUnit } from '@/interfaces/elastic/elastic.interface';
  import { useI18n } from 'vue-i18n';
  import RentalUnitShow from '@/components/announcement/RentalUnit/RentalUnitShow.vue';
  import { computed, ref } from 'vue';

  interface Props {
    rentalUnits?: RentalUnit[];
    hidePrice?: boolean;
    language: string;
  }

  const props = defineProps<Props>();
  const { t } = useI18n();

  const showAll = ref<boolean>(false);

  const displayedRentalUnits = computed<RentalUnit[] | undefined>(() => {
    if (showAll.value) {
      return props.rentalUnits;
    }
    return props.rentalUnits?.slice(0, 3);
  });
</script>
<style scoped lang="scss"></style>
